import GuardedRoute from "@/routes/components/GuardedRoute";
import { findNavItemByKey } from "@/routes/lib/findNavItemByKey";
import { INavMenu, RouteConfig } from "@types";
import { Navigate, Route } from "react-router-dom";

export const renderRoutes = (routes: RouteConfig[], nav: INavMenu) =>
  routes.map(({ path, element, children, redirect }) => {
    const allNavItems = Object.values(nav).flat();

    return (
      <Route key={path} path={path} element={element}>
        {redirect && (
          <Route path="" element={<Navigate replace to={redirect} />} />
        )}
        {children &&
          children.map((child) => {
            let isAllow = true;
            if (child.navKey) {
              const found = findNavItemByKey(allNavItems, child.navKey);
              isAllow = found?.isAllow ?? true;
            }
            return (
              <Route
                key={child.path}
                path={child.path}
                element={
                  child.element ? (
                    <GuardedRoute isAllow={isAllow}>
                      {child.element}
                    </GuardedRoute>
                  ) : null
                }
              />
            );
          })}
      </Route>
    );
  });
